import { jsx as _jsx } from "react/jsx-runtime";
import { generateUUID } from '@nu-art/ts-common';
const calculatorOperators = [
    {
        operand: '===',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: "===" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
    {
        operand: '+',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: "+" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
    {
        operand: '-',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: "-" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
    {
        operand: '/',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: "/" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
    {
        operand: '*',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: "*" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
    {
        operand: '^',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: "^" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
    {
        operand: '?',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: "?" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
    {
        operand: ':',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: ":" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
    {
        operand: '""',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: "\"\"" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 1) => {
            return cursorPosition - offset;
        }
    },
];
// const hcsOperators: CalculatorButton[] = [
// 	{
// 		operand: 'var()',
// 		element: (onClick) => <div tabIndex={0} key={generateUUID()} onClick={onClick} className={'calc-btn'}>var()</div>,
// 		cursorLocationLogic: (cursorPosition, offset = 1) => {
// 			return cursorPosition - offset;
// 		}
// 	},
// 	{
// 		operand: 'enum()',
// 		element: (onClick) => <div tabIndex={0} key={generateUUID()} onClick={onClick} className={'calc-btn'}>enum()</div>,
// 		cursorLocationLogic: (cursorPosition, offset = 1) => {
// 			return cursorPosition - offset;
// 		}
// 	},
// 	{
// 		operand: 'attr()',
// 		element: (onClick) => <div tabIndex={0} key={generateUUID()} onClick={onClick} className={'calc-btn'}>attr()</div>,
// 		cursorLocationLogic: (cursorPosition, offset = 1) => {
// 			return cursorPosition - offset;
// 		}
// 	},
// 	{
// 		operand: 'precipitating()',
// 		element: (onClick) => <div tabIndex={0} key={generateUUID()} onClick={onClick} className={'calc-btn'}>precipitating()</div>,
// 		cursorLocationLogic: (cursorPosition, offset = 1) => {
// 			return cursorPosition - offset;
// 		}
// 	},
// 	{
// 		operand: 'relieving()',
// 		element: (onClick) => <div tabIndex={0} key={generateUUID()} onClick={onClick} className={'calc-btn'}>relieving()</div>,
// 		cursorLocationLogic: (cursorPosition, offset = 1) => {
// 			return cursorPosition - offset;
// 		}
// 	},
// 	{
// 		operand: 'yes',
// 		element: (onClick) => <div tabIndex={0} key={generateUUID()} onClick={onClick} className={'calc-btn'}>yes</div>,
// 		cursorLocationLogic: (cursorPosition, offset = 0) => {
// 			return cursorPosition + offset;
// 		}
// 	},
// 	{
// 		operand: 'no',
// 		element: (onClick) => <div tabIndex={0} key={generateUUID()} onClick={onClick} className={'calc-btn'}>no</div>,
// 		cursorLocationLogic: (cursorPosition, offset = 0) => {
// 			return cursorPosition + offset;
// 		}
// 	}
// ];
const numericComparisons = [
    {
        operand: '<',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: '<' }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
    {
        operand: '>',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: '>' }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
    {
        operand: '<=',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: '<=' }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
    {
        operand: '>=',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: '>=' }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
];
const parenthesisOperators = [
    {
        operand: '[]',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: "[]" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 1) => {
            return cursorPosition - offset;
        }
    },
    {
        operand: '(',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: "(" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition - offset;
        }
    },
    {
        operand: ')',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: ")" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition - offset;
        }
    },
];
const expressionOperators = [
    {
        operand: '||',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: "||" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
    {
        operand: '&&',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: "&&" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
    {
        operand: '+',
        element: (onClick) => _jsx("div", { tabIndex: 0, onClick: onClick, className: 'calc-btn', children: "+" }, generateUUID()),
        cursorLocationLogic: (cursorPosition, offset = 0) => {
            return cursorPosition + offset;
        }
    },
];
export const booleanExpressions = [
    ...expressionOperators,
    ...parenthesisOperators
];
export const allOperators = [
    ...expressionOperators,
    ...numericComparisons,
    ...parenthesisOperators,
    ...calculatorOperators,
    // ...hcsOperators,
];
//# sourceMappingURL=EditorOperators.js.map